const ITEMS = [
  "ECU Remapping",
  "Stage 1 Tuning",
  "Vehicle Diagnostics",
  "Car Tuning",
  "Rochdale — Greater Manchester",
];

const ALT_ITEMS = [
  "Unlock Your Vehicle's Potential",
  "Professional Equipment",
  "Transparent Pricing",
  "Attention to Detail",
  "Customer First",
];

export default function Marquee({ reverse = false }) {
  const list = reverse ? ALT_ITEMS : ITEMS;

  const row = (key) => (
    <div key={key} className="flex shrink-0 items-center" aria-hidden={key === "b"}>
      {list.map((t, i) => (
        <span key={i} className="flex items-center">
          <span
            className={`px-8 font-display text-3xl sm:text-5xl font-semibold uppercase tracking-tight whitespace-nowrap ${
              i % 2 ? "text-outline" : "text-white"
            }`}
          >
            {t}
          </span>
          <span className="h-2 w-2 rotate-45 bg-electric shrink-0" />
        </span>
      ))}
    </div>
  );

  return (
    <div
      className="relative overflow-hidden border-y border-white/10 bg-[#050505] py-7"
      data-testid={reverse ? "marquee-reverse" : "marquee"}
    >
      <div className="marquee-track" style={reverse ? { animationDirection: "reverse" } : undefined}>
        {row("a")}
        {row("b")}
      </div>
    </div>
  );
}
